import { NgModule } from '@angular/core';
import { ExcelhealthComponentsComponent } from './excelhealth-components.component';

@NgModule({
  declarations: [ExcelhealthComponentsComponent],
  imports: [
  ],
  exports: [ExcelhealthComponentsComponent]
})
export class ExcelhealthComponentsModule { }
